import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../../components/Layout";
import BlackWhiteButton from "../../../components/buttons/BlackWhiteButton";
import {
  List,
  ListHeader,
  ListHeaderItem,
  ListHeaderItemDropdown,
  ListBody,
  ListBodyCell,
  ListBodyItem,
  ListBodyItemImage,
} from "../../../components/_widgets/WidgetsList";
import { getProductAll, getCategories, AllEstablishment, getCategoriesChildren } from "../../../config/utils";
import api from "../../../config/api";
import SearchInput from "../../../components/inputs/SearchInput";
import { Spinner } from "react-bootstrap";
require("dotenv").config();

function Product() {
  const [products, setProducts] = useState([]);

  // Filter
  const [productsAll, setProductsAll] = useState([]);
  const [establishmentAll, setEstablishmentAll] = useState([]);
  const [productSegment, setProductSegment] = useState([]);
  const [categoryChildrenAll, setCategoryChildrenAll] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [headerNameFilter, setHeaderNameFilter] = useState("");
  // const [headerSegmentFilter, setHeaderSegmentFilter] = useState("");
  const [headerCategoryFilter, setHeaderCategoryFilter] = useState("");
  const [headerEstablishmentFilter, setHeaderEstablishmentFilter] = useState("");
  const [selectedEstablishment, setSelectedEstablishment] = useState("");
  const [selectedCategoryChildren, setSelectedCategoryChildren] = useState("");
  const [nameFilter, setNameFilter] = useState("");
  const [segment, setSegment] = useState("");

  const [loading, setLoading] = useState(true);

  // Pagination
  const [qtLimitItem, setQtLimitItem] = useState(10);
  const [pageItemsList, setPageItemsList] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  useEffect(() => {
    getProduct(
      pageItemsList,
      qtLimitItem,
      selectedProduct,
      selectedEstablishment,
      selectedCategoryChildren,
      nameFilter,
      segment
    );
    getAllProduct();
    getAllEstablishment();
    getAllCategories();
    getAllCategoriesChildren();
  }, []);

  const getProduct = async (
    page,
    limit,
    selectedProduct,
    selectedEstablishment,
    selectedCategoryChildren,
    nameFilter,
    segment
  ) => {
    try {
      const response = await api.get(
        `/product?paginate=true&page=${page}&limit=${limit}&productFilter=${selectedProduct}&establishment=${selectedEstablishment}&category=${selectedCategoryChildren}&name=${nameFilter}&segment=${segment}}`
      );
      setProducts(response.data.docs);
      setTotalItems(response.data.total);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Pagination
  const setLimitList = (value) => {
    setQtLimitItem(value);
    getProduct(
      pageItemsList,
      value,
      selectedProduct,
      selectedEstablishment,
      selectedCategoryChildren,
      nameFilter,
      segment
    );
  };

  const changePage = (event) => {
    setPageItemsList(Number(event.target.id));
    getProduct(
      event.target.id,
      qtLimitItem,
      selectedProduct,
      selectedEstablishment,
      selectedCategoryChildren,
      nameFilter,
      segment
    );
  };

  const prevButton = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
      getProduct(
        pageItemsList - 1,
        qtLimitItem,
        selectedProduct,
        selectedEstablishment,
        selectedCategoryChildren,
        nameFilter,
        segment
      );
    }
  };

  const nextButton = () => {
    let qtPages = Math.ceil(totalItems / qtLimitItem);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(pageItemsList + 1);
      getProduct(
        pageItemsList + 1,
        qtLimitItem,
        selectedProduct,
        selectedEstablishment,
        selectedCategoryChildren,
        nameFilter,
        segment
      );
    }
  };

  // Filter
  const getAllProduct = async () => {
    let res = await getProductAll();
    setTotalItems(res.total);
    setProductsAll(res.list);
  };

  const getAllEstablishment = async () => {
    let res = await AllEstablishment();
    setEstablishmentAll(res.list);
  };

  const getAllCategories = async () => {
    let res = await getCategories();
    setProductSegment(res);
  };

  const getAllCategoriesChildren = async () => {
    let res = await getCategoriesChildren();
    setCategoryChildrenAll(res);
  };

  const handleSelectProduct = (value) => {
    setSelectedProduct(value);
    setPageItemsList(1);
    getProduct(1, qtLimitItem, value, selectedEstablishment, selectedCategoryChildren, nameFilter, segment);
  };

  const handleSelectEstablishment = (value) => {
    setSelectedEstablishment(value);
    setPageItemsList(1);
    getProduct(1, qtLimitItem, selectedProduct, value, selectedCategoryChildren, nameFilter, segment);
  };

  const handleSelectCategoryChildren = (value) => {
    setSelectedCategoryChildren(value);
    setPageItemsList(1);
    getProduct(1, qtLimitItem, selectedProduct, selectedEstablishment, value, nameFilter, segment);
  };

  const handleInputFilter = (value) => {
    setPageItemsList(1);
    setNameFilter(value);
    getProduct(1, qtLimitItem, selectedProduct, selectedEstablishment, selectedCategoryChildren, value, segment);
  };

  // const handleSelectSegmentChildren = (value) => {
  //   setSegment(value);
  //   getProduct(
  //     pageItemsList,
  //     qtLimitItem,
  //     selectedProduct,
  //     selectedEstablishment,
  //     selectedCategoryChildren,
  //     nameFilter,
  //     value
  //   );
  // };

  const handleHeaderNameFilterChange = (e) => {
    setHeaderNameFilter(e.target.value);
  };
  // const handleHeaderSegmentFilterChange = (e) => {
  //   setHeaderSegmentFilter(e.target.value);
  // };
  const handleHeaderEstablishmentFilterChange = (e) => {
    setHeaderEstablishmentFilter(e.target.value);
  };
  const handleHeaderCategoryFilterChange = (e) => {
    setHeaderCategoryFilter(e.target.value);
  };

  const filteredHeaderProducts = useMemo(() => {
    return productsAll.filter((product) => product.name.toLowerCase().includes(headerNameFilter.toLowerCase()));
  }, [headerNameFilter, productsAll]);

  // const filteredHeaderSegment = useMemo(() => {
  //   return productSegment.filter((product) => product.name.toLowerCase().includes(headerSegmentFilter.toLowerCase()));
  // }, [headerSegmentFilter, productSegment]);

  const filteredHeaderCategory = useMemo(() => {
    return categoryChildrenAll.filter((product) =>
      product.name.toLowerCase().includes(headerCategoryFilter.toLowerCase())
    );
  }, [headerCategoryFilter, categoryChildrenAll]);

  const filteredHeaderEstablishments = useMemo(() => {
    return establishmentAll.filter((establishment) =>
      establishment.storeName.toLowerCase().includes(headerEstablishmentFilter.toLowerCase())
    );
  }, [headerEstablishmentFilter, establishmentAll]);

  const exportTable = async () => {
    await api
      .get(`/products-excel`, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Layout defaultMenu={3} title={"Produtos"} link={""}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="d-flex flex-column flex-lg-row">
            <SearchInput value={nameFilter} onChange={handleInputFilter} className={"me-auto mb-3"} />
            <BlackWhiteButton
              onClick={() => exportTable()}
              className="mb-3 py-2"
              size={2}
              sizeLg={"auto"}
              text="Exportar planilha"
            />
          </div>
          <div className="d-flex flex-column flex-lg-row pb-4">
            <List
              section={"produtos"}
              onChange={(e) => setLimitList(e.target.value)}
              limit={qtLimitItem}
              totalItem={totalItems}
              page={pageItemsList}
              prevButton={() => prevButton()}
              nextButton={() => nextButton()}
              changePage={(e) => changePage(e)}
            >
              <ListHeader>
                <ListHeaderItem sizeLg={2} title={""} />
                <ListHeaderItem sizeLg={3} title={"Nome do produto"} filter={selectedProduct}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por estabelecimento"}
                          onChange={handleHeaderNameFilterChange}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div key={"all"} onClick={() => handleSelectProduct("")} className="dropdown-item">
                        <span>Todos</span>
                      </div>
                      {filteredHeaderProducts.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleSelectProduct(item._id)}
                          className="dropdown-item"
                          style={selectedProduct === item._id ? { backgroundColor: "#0d80ff", color: "white" } : {}}
                        >
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={2} title={"Segmento"}></ListHeaderItem>
                <ListHeaderItem sizeLg={3} title={"Estabelecimento"} filter={selectedEstablishment}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por estabelecimento"}
                          onChange={handleHeaderEstablishmentFilterChange}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div
                        key={"allEstablishment"}
                        onClick={() => handleSelectEstablishment("")}
                        className="dropdown-item"
                      >
                        <span>Todos</span>
                      </div>
                      {establishmentAll.length ? (
                        <>
                          {establishmentAll.map((item, index) => (
                            <div
                              key={index}
                              onClick={() => handleSelectEstablishment(item._id)}
                              className={`dropdown-item`}
                              style={
                                selectedEstablishment === item._id ? { backgroundColor: "#0d80ff", color: "white" } : {}
                              }
                            >
                              <span>{item.storeName}</span>
                            </div>
                          ))}
                        </>
                      ) : (
                        <span className="d-flex align-items-center justify-content-center py-2">
                          <Spinner
                            animation="border"
                            role="status"
                            style={{ height: "2rem", width: "2rem", borderWidth: "0.2em" }}
                          >
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </span>
                      )}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                <ListHeaderItem sizeLg={2} title={"Categoria"} filter={selectedCategoryChildren}>
                  <ListHeaderItemDropdown>
                    <li
                      className="dropdown-header d-flex justify-content-end pt-0 pb-1 px-2"
                      style={{ borderBottom: "1px solid #D9D9D9" }}
                    >
                      <div className="input-group input-search">
                        <input
                          type="text"
                          style={{ width: "173px" }}
                          className="input-dropdown form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto px-1 pb-0"
                          placeholder={"Procure por estabelecimento"}
                          onChange={handleHeaderCategoryFilterChange}
                        />
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search " style={{ color: "#000000" }}></i>
                        </span>
                      </div>
                    </li>
                    <div className="filter-items" style={{ maxHeight: "238px" }}>
                      <div
                        key={"allCategoryChildren"}
                        onClick={() => handleSelectCategoryChildren("")}
                        className="dropdown-item"
                      >
                        <span>Todos</span>
                      </div>
                      {filteredHeaderCategory.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handleSelectCategoryChildren(item._id)}
                          className="dropdown-item"
                          style={
                            selectedCategoryChildren === item._id ? { backgroundColor: "#0d80ff", color: "white" } : {}
                          }
                        >
                          <span>{item.name}</span>
                        </div>
                      ))}
                    </div>
                  </ListHeaderItemDropdown>
                </ListHeaderItem>
                {/* <ListHeaderItem sizeLg={2} title={"Reservas concluídas"} /> */}
              </ListHeader>
              <ListBody>
                {loading ? (
                  <>
                    <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ height: "8rem", width: "8rem", borderWidth: "0.8em" }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    </div>
                  </>
                ) : (
                  <>
                    {products.length ? (
                      <>
                        {products?.map((item, index) => {
                          const productCategory = productSegment.find(
                            (productCategory) => productCategory._id === item?.category?.parent
                          );
                          return (
                            <ListBodyCell key={index} className={`${index % 2 !== 0 ? "bg-cl-cultured" : ""}`}>
                              <ListBodyItemImage sizeLg={2} description={""} title={item?.productPhoto} />
                              <ListBodyItem sizeLg={3} description={"Nome do Produto"} title={item?.name} />
                              <ListBodyItem sizeLg={2} description="Segmento" title={productCategory?.name} />
                              <ListBodyItem
                                sizeLg={3}
                                description={"Estabelecimento"}
                                title={item?.establishment?.storeName}
                              />
                              <ListBodyItem sizeLg={2} description={"Categoria"} title={item?.category?.name} />
                              {/* <ListBodyItemLink
                        link={item?.link}
                        sizeLg={2}
                        description={"Reservas concluídas"}
                        title={item?.vendas}
                      /> */}
                            </ListBodyCell>
                          );
                        })}
                      </>
                    ) : (
                      <div className="d-flex justify-content-center py-5 text-cl-auroMetal">
                        <span> Nenhum produto cadastrado nesse estabelecimento</span>
                      </div>
                    )}
                  </>
                )}
              </ListBody>
            </List>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Product;
